import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import http from 'http'

import FilterByProperty from 'components/FilterByProperty'
import ByDate from './ByDate'

import {
  FiFilter,
  FiCheck,
  FiX
} from 'react-icons/fi'

import { AiOutlineClear } from 'react-icons/ai'

const Filter = () => {
  const [ searchParams, setSearchParams ] = useSearchParams()
  const [ isOpen, setIsOpen ] = useState( false )
  const _with = useState( [] )
  const level = useState( [] )
  const time = useState( [
    { name: 'all' },
    { name: 'yearly' },
    { name: 'monthly' },
    { name: 'weekly' }
  ] )

  const toggle = () => {
    setIsOpen( ! isOpen )
  }

  const getValues = ( [ values ] ) => {
    const aux = [ ...values ]

    return aux
      .filter( i => i.selected )
      .map( i => i.name )
  }

  const applyFilters = () => {
    const w = getValues( _with )
    const l = getValues( level )
    const t = getValues( time )

    setSearchParams( searchParams => {
      if ( w.length > 0 )
        searchParams.set( 'with', JSON.stringify( w ) )
      else
        searchParams.delete( 'with' )

      if ( l.length > 0 )
        searchParams.set( 'level', JSON.stringify( l ) )
      else
        searchParams.delete( 'level' )

      if ( t.length > 0 )
        searchParams.set( 'time', t[ 0 ] )
      else
        searchParams.delete( 'time' )

      return searchParams
    } )

    toggle()
  }

  const clean = ( [ v, update ] ) => {
    update( values => {
      return values
        .map( i => ( { ...i, selected: false } ) )
    } )
  }

  const cleanFilters = () => {
    clean( _with )
    clean( level )
    clean( time )

    setSearchParams( searchParams => {
      searchParams.delete( 'with' )
      searchParams.delete( 'level' )
      searchParams.delete( 'time' )
      return searchParams
    } )

    toggle()
  }

  return <>
    { ! isOpen ? <button
      onClick={ toggle }
    >
      <FiFilter />
    </button> : <div className="scroll modal full hs">
      <div className="bar">
        <h1>filters</h1>

        <button
          onClick={ applyFilters }
        >
          <FiCheck />
        </button>

        <button
          onClick={ cleanFilters }
        >
          <AiOutlineClear />
        </button>

        <button
          onClick={ toggle }
        >
          <FiX />
        </button>
      </div>

      <div className="scroll one hs">

        <ByDate
          state={ time }
        />

        <FilterByProperty
          fieldName="with"
          state={ _with }
        />

        <FilterByProperty
          fieldName="level"
          state={ level }
        />

      </div>
    </div> }
  </>
}

export default Filter
